import commonService from "../../common";

export const getSelectStationArray = (masterBook) => {
  const returnStations = [];
  commonService
    .sortByDisplayOrder(masterBook.master_prices)
    .forEach((price) => {
      // 重複は弾く
      if (
        !returnStations.some(
          (station) => station.code == price.from_station.code
        )
      ) {
        returnStations.push({
          name: price.from_station.name,
          code: price.from_station.code,
        });
      }
    });
  return returnStations;
};
